const initState = {
  workActivity: [],
  successFetching: false,
  errorFetching: false,
};

export default initState;
